export default __webpack_public_path__ + "static/media/9127 - Richard.ad1f54fc.jpeg";